import { ArrowShapeTool } from "./shapes/arrow/ArrowShapeTool.mjs";
import { DrawShapeTool } from "./shapes/draw/DrawShapeTool.mjs";
import { FrameShapeTool } from "./shapes/frame/FrameShapeTool.mjs";
import { GeoShapeTool } from "./shapes/geo/GeoShapeTool.mjs";
import { HighlightShapeTool } from "./shapes/highlight/HighlightShapeTool.mjs";
import { LineShapeTool } from "./shapes/line/LineShapeTool.mjs";
import { NoteShapeTool } from "./shapes/note/NoteShapeTool.mjs";
import { TextShapeTool } from "./shapes/text/TextShapeTool.mjs";
const defaultShapeTools = [
  TextShapeTool,
  DrawShapeTool,
  GeoShapeTool,
  NoteShapeTool,
  LineShapeTool,
  FrameShapeTool,
  ArrowShapeTool,
  HighlightShapeTool
];
export {
  defaultShapeTools
};
//# sourceMappingURL=defaultShapeTools.mjs.map
